import { officeEntityModalConstants as C } from "../actions/constants";

const initialState = {
    open: false,
    type: "",
    entityId: "",
    officeId: "",
    source: "",
    sourceTitle: "",
    payload: null,
    openedAt: null,
};

export default function officeEntityModalReducer(state = initialState, action) {
    switch (action.type) {
        case C.OFFICE_ENTITY_MODAL_OPEN:
            return {
                ...initialState,
                open: true,
                ...(action.payload || {}),
            };

        case C.OFFICE_ENTITY_MODAL_CLOSE:
            return initialState;

        default:
            return state;
    }
}
